export enum FieldUpdateCostBillLadingExcel {
    LadingCode = 'ladingCode',
    Money = 'money'
}